import { render, staticRenderFns } from "./CheckDataFromFileStepTwo.vue?vue&type=template&id=4f8838ec&"
import script from "./CheckDataFromFileStepTwo.vue?vue&type=script&lang=js&"
export * from "./CheckDataFromFileStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./CheckDataFromFileStepTwo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports